import React from 'react';
import { Form, Button, InputGroup, Badge } from 'react-bootstrap';
import { FaFilter, FaBuilding } from 'react-icons/fa';
import './Filter.css';

const Filter = ({ count, darkMode }) => {
  return (
    <div className={`map-filter-wrapper ${darkMode ? 'dark' : 'light'}`}>
      <div className="map-filter-container">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <FaBuilding className="me-2" />
            <h5 className="m-0 me-2">Mapa de Unidades</h5>
          </div>
          <Badge bg={darkMode ? "light" : "secondary"} text={darkMode ? "dark" : "light"} className="map-count-badge">
            {count} unidades
          </Badge>
        </div>
      </div>
    </div>
  );
};

export default Filter;
